import { render, staticRenderFns } from "./front-page-article.vue?vue&type=template&id=6fa36124"
import script from "./front-page-article.vue?vue&type=script&lang=js"
export * from "./front-page-article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports